import angular from 'angular';
import durationService from '../../../services/duration.service';


const durationTextComponent = angular.module('ttb.widgets.durationText.component', [
    durationService,
])
    .component('durationText', {
        template: `
            <span ng-class="{'text-danger': $ctrl.value.invalid}">{{$ctrl.durationView}}</span>
        `,
        bindings: {
            value: '<',
            formatter: '<'
        },
        controller: DurationText
    })
    .name;

function DurationText() {
    const INVALID_MESSAGE = 'invalid value';
    const updateDurationView = () => {
        this.durationView = this.formatter
            ? this.formatter.format(this.value || {}, INVALID_MESSAGE)
            : '';
    };
    this.$onInit = () => {
        updateDurationView();
    };
    this.$onChanges = (changes) => {
        updateDurationView();
    };
}
DurationText.$inject = [];

export default durationTextComponent;


// WEBPACK FOOTER //
// ../widgets/duration/text/duration-text.component.js